var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Dashboard"}},[_c('Wrap',{staticClass:"lg"},[_c('h2',[_vm._v("Dashboard")]),_c('ImportForm',{attrs:{"importData":_vm.importData}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }